export default __webpack_public_path__ + "static/svatby_poster-0f718461dcccd6eb01eab6981044ee06.webp";